import React, { useEffect, useMemo, useState } from 'react';
import { EmailPreviewFrame } from '../email/EmailEditor';

// Выбор email-шаблона из «Сообщений»: превью до подтверждения выбора. Шаблон без
// ссылки отписки выбрать нельзя — массовая отправка без Unsubscribe запрещена.
const EmailContentStep = ({ formData, updateFormData, setIsFormValid }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [previewId, setPreviewId] = useState(formData.emailTemplateId || null);
  const [device, setDevice] = useState('desktop');

  useEffect(() => {
    fetch('/api/v1/email_templates')
      .then((r) => r.json())
      .then((data) => setTemplates(data.templates || []))
      .finally(() => setLoading(false));
  }, []);

  const chosen = templates.find((t) => String(t.id) === String(formData.emailTemplateId));
  const previewed = templates.find((t) => String(t.id) === String(previewId));

  useEffect(() => {
    setIsFormValid(!!(chosen && chosen.sendable));
  }, [chosen, setIsFormValid]);

  const visible = useMemo(
    () => templates.filter((t) => !search || t.name.toLowerCase().includes(search.toLowerCase())),
    [templates, search]
  );

  const choose = (t) =>
    updateFormData({ emailTemplateId: t.id, emailTemplateName: t.name, emailSubject: t.subject, emailPreheader: t.preheader });

  return (
    <div className='grid grid-cols-5 gap-4'>
      <div className='col-span-2'>
        <input className='shadow-sm border border-gray-300 rounded px-2 py-1.5 text-sm w-full mb-2' placeholder='Search email templates…' value={search} onChange={(e) => setSearch(e.target.value)} />
        <div className='border border-gray-200 rounded-lg divide-y divide-gray-100 max-h-[420px] overflow-y-auto'>
          {loading && <div className='p-4 text-sm text-gray-500'>Loading…</div>}
          {!loading && visible.length === 0 && (
            <div className='p-4 text-sm text-gray-500'>
              No email templates. <a className='text-blue-600' href='/email_templates/new'>Create one in Messages</a>.
            </div>
          )}
          {visible.map((t) => (
            <button
              type='button'
              key={t.id}
              onClick={() => setPreviewId(t.id)}
              className={`w-full text-left px-3 py-2 hover:bg-gray-50 ${String(previewId) === String(t.id) ? 'bg-blue-50' : ''}`}
            >
              <div className='flex items-center gap-2'>
                <span className='text-sm font-medium text-gray-900 truncate'>{t.name}</span>
                {String(formData.emailTemplateId) === String(t.id) && <span className='text-xs text-green-700'>✓ selected</span>}
                {!t.sendable && <span className='text-xs text-red-600'>no unsubscribe</span>}
              </div>
              <div className='text-xs text-gray-500 truncate'>{t.subject}</div>
            </button>
          ))}
        </div>
      </div>

      <div className='col-span-3'>
        {previewed ? (
          <div>
            <div className='flex items-start justify-between gap-2 mb-2'>
              <div className='min-w-0'>
                <div className='text-sm font-semibold text-gray-900 truncate'>{previewed.subject}</div>
                {previewed.preheader && <div className='text-xs text-gray-500 truncate'>{previewed.preheader}</div>}
              </div>
              <div className='flex bg-gray-100 rounded p-0.5 shrink-0'>
                {['desktop', 'mobile'].map((d) => (
                  <button type='button' key={d} onClick={() => setDevice(d)} className={`px-2 py-0.5 text-xs rounded ${device === d ? 'bg-white shadow-sm' : 'text-gray-500'}`}>
                    {d === 'desktop' ? 'Desktop' : 'Mobile'}
                  </button>
                ))}
              </div>
            </div>
            <EmailPreviewFrame html={previewed.html} device={device} height={380} />
            <div className='mt-3 flex items-center justify-between'>
              {previewed.sendable ? (
                <span className='text-xs text-gray-500'>The campaign keeps its own copy — later template edits won't change it.</span>
              ) : (
                <span className='text-xs text-red-600'>This email has no Unsubscribe link and cannot be sent.</span>
              )}
              <button
                type='button'
                disabled={!previewed.sendable}
                onClick={() => choose(previewed)}
                className='px-3 py-1.5 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-40'
              >
                {String(formData.emailTemplateId) === String(previewed.id) ? 'Selected' : 'Use this email'}
              </button>
            </div>
          </div>
        ) : (
          <div className='h-full min-h-[200px] flex items-center justify-center text-sm text-gray-500 border border-dashed border-gray-300 rounded-lg'>
            Pick a template on the left to preview it
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailContentStep;
